import React from "react";
import { isEmpty } from "lodash";
import StatsPanel from "../chart-container";
import { Button, CircularProgress, Grid, Typography } from "@material-ui/core";
import DatePicker from "../../../base/date-picker";
import DashboardWidgetService from "../../../../services/dashboard-widgets";
import moment from "moment";
import SubscriptionExpirationTable from "./subscription-expiration-table";

import "./style.css";

const SubscriptionExpirationOverview = () => {
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [submitCount, setSubmitCount] = React.useState(0);
  const [subscriptionExpirations, setSubscriptionExpirations] = React.useState(
    []
  );

  const btnDisabled = React.useMemo(() => {
    return (
      !startDate || !endDate || moment(startDate).isAfter(endDate) || loading
    );
  }, [endDate, loading, startDate]);

  const onClickShowResults = React.useCallback(async () => {
    setLoading(true);
    setSubscriptionExpirations([]);
    setError("");
    try {
      const response = await DashboardWidgetService.getSubscriptionExpirations({
        from: moment(startDate).format("YYYY-MM-DD"),
        to: moment(endDate).format("YYYY-MM-DD"),
      });
      if (!response.success) {
        setError(response.body?.message ?? "Error Occured");
        return;
      }
      setSubscriptionExpirations(response.body);
    } catch (error) {
      setError(error.message ?? "Error Occurred");
    } finally {
      setTimeout(() => {
        setSubmitCount(submitCount + 1);
        setLoading(false);
      }, 1000);
    }
  }, [endDate, startDate, submitCount]);

  const maxDate = moment().add(6, "month").format("YYYY-MM-DD");

  return (
    <StatsPanel
      title="Subscription Expirations"
      rootCSSClass="subscription-expiration-overview"
    >
      <Grid container direction="column" className="gap-y-16">
        <Grid container direction="row" className="gap-x-16">
          <DatePicker
            label="From"
            selectedDate={startDate}
            onChangeDate={(date) => setStartDate(date)}
            maxDate={maxDate}
          />
          <DatePicker
            label="To"
            selectedDate={endDate}
            onChangeDate={(date) => setEndDate(date)}
            maxDate={maxDate}
          />
          <Button
            className="show-results-btn"
            disabled={btnDisabled}
            startIcon={loading && <CircularProgress size={15} />}
            onClick={onClickShowResults}
          >
            Show Results
          </Button>
        </Grid>
        {!isEmpty(error) && (
          <Typography variant="body2" className="widget-error">
            {error}&nbsp;&nbsp; &nbsp;
            <span className="try-agian" onClick={onClickShowResults}>
              try again!
            </span>
          </Typography>
        )}
        {!isEmpty(subscriptionExpirations) && (
          <SubscriptionExpirationTable data={subscriptionExpirations} />
        )}
        {submitCount > 0 &&
          isEmpty(subscriptionExpirations) &&
          isEmpty(error) && (
            <Typography variant="body1">No Results Found</Typography>
          )}
      </Grid>
    </StatsPanel>
  );
};

export default React.memo(SubscriptionExpirationOverview);
